import { mapAppLocale } from '@protector/utils/app-locale-map';
import { setMomentLocale } from 'config/moment-import';
import { getCurrentLanguage } from 'core/utils/functions';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useUpdateMomentLocale = () => {
  const [t] = useTranslation();

  useEffect(() => {
    const currentLanguage = mapAppLocale(getCurrentLanguage());

    if (currentLanguage === 'en') {
      setMomentLocale('en', {
        longDateFormat: {
          LT: 'HH:mm',
          LTS: 'HH:mm:ss',
          L: 'DD/MM/YYYY',
          LL: 'D MMMM YYYY',
          LLL: 'D MMMM YYYY HH:mm',
          LLLL: 'dddd D MMMM YYYY HH:mm'
        }
      });
    } else {
      setMomentLocale(currentLanguage);
    }
  }, [t]);
};

export default useUpdateMomentLocale;
